const initialState = {
  fullLoading: true,
  redirect: null,
  cookie: null
}

export default (state = initialState, action) => {
  let nextState = { ...state }

  switch (action.type) {
    case 'SET_REDIRECT':
      nextState.redirect = action.data
      break

    case 'SET_CLEAN_REDIRECT':
      nextState.redirect = null
      break

    case 'SET_COOKIE':
      nextState.cookie = {
        action: action.action ? action.action : 'set',
        name: action.name,
        value: action.value
      }
      break

    case 'SET_CLEAN_COOKIE':
      nextState.cookie = null
      break

    case 'SET_FULL_LOADING':
      nextState.fullLoading = action.data
      break

    default:
      nextState = state
      break
  }

  return nextState
}
